// AUTO-GENERATED by scripts/gen-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  commit: "6c82e62",
  branch: "HEAD",
  buildTime: "2026-11-03T16:03:24.570Z",
} as const;
